
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/artifacts",
      function () {
        return require("private-next-pages/docs/api/artifacts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/artifacts"])
      });
    }
  